import './styles.css';

import Marquee from 'react-fast-marquee';

import React, { useEffect, useState } from 'react';
import { OPS_API_URL } from '../../constants/config';

const DisclaimerBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const fetchShowDisclaimerStatus = async () => {
      try {
        const response = await fetch(`${OPS_API_URL}/api/public/global/showDisclaimerBanner`, {
          method: 'GET',
          headers: {
            'content-type': 'application/json',
          },
        });

        if (!response.ok) {
          setShow(false);
        }

        const { data } = await response.json();

        setShow(data);
      } catch (error) {
        console.error('Error while fetching disclaimer status', error);
      }
    };

    fetchShowDisclaimerStatus();
  }, []);

  if (show !== 'true') {
    return null;
  }

  return (
    <div className="disclaimer-banner">
      <Marquee>
        <text style={{ paddingRight: '4px' }}>
          Due to technical reasons, our regular phone lines are currently unavailable. Please contact us via WhatsApp at
          +1-408-591-0742 & +1-408-591-0751 for assistance.
        </text>
      </Marquee>
    </div>
  );
};

export default DisclaimerBanner;
